<template>
  <div class="sample-information-view">
    <SampleInformationTabs />
  </div>
</template>

<script>
import SampleInformationTabs from "../components/layout/SampleInformation/SampleInformationTabs.vue";

export default {
  name: "SampleValidation",
  components: {
    SampleInformationTabs,
  },
};
</script>
